import { ChangeDetectorRef, Component, Input, computed, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ToastMessage,
  ToastService,
  ToastSeverity,
  ToastPosition,
} from '@services/toast/toast.service';

@Component({
    selector: 'app-toast',
    imports: [CommonModule],
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
})
export class ToastComponent {
  @Input() position: ToastPosition = 'bottom-right';

  private readonly toastService = inject(ToastService);
  private readonly cdr = inject(ChangeDetectorRef);

  readonly topRightToasts = computed(() => this.filterByPosition('top-right'));
  readonly topLeftToasts = computed(() => this.filterByPosition('top-left'));
  readonly bottomRightToasts = computed(() => this.filterByPosition('bottom-right'));
  readonly bottomLeftToasts = computed(() => this.filterByPosition('bottom-left'));

  constructor() {
    effect(() => {
      this.toastService.toasts();
      this.cdr.markForCheck();
    });
  }

  private filterByPosition(position: ToastPosition): ToastMessage[] {
    return this.toastService
      .toasts()
      .filter((toast) => (toast.position || this.position) === position);
  }

  removeToast(id: number): void {
    this.toastService.remove(id);
  }

  getIcon(severity: ToastSeverity): string {
    switch (severity) {
      case ToastSeverity.SUCCESS:
        return 'check_circle';
      case ToastSeverity.INFO:
        return 'info';
      case ToastSeverity.WARN:
        return 'warning';
      case ToastSeverity.ERROR:
        return 'error';
      default:
        return 'info';
    }
  }
}
